// ─── Immatriculations ─────────────────────────────────────────────────────────
// Datacar livre les plaques dans des formes instables : « GK-482- MV »,
// « GK482MV », parfois une espace au milieu. Les écrans les AFFICHENT nettoyées
// depuis toujours (`.replace(/[-\s]/g, '')`) — mais les recherches comparaient
// la valeur BRUTE. Taper exactement ce qu'on lit à l'écran ne trouvait donc
// rien : la ligne était là, le filtre répondait « aucune commande ».
//
// Règle : on affiche nettoyé, donc on cherche nettoyé — des deux côtés.

/** Forme affichée : sans tiret ni espace (comportement historique conservé). */
export const afficherImmat = (v) => String(v || '').replace(/[-\s]/g, '');

/** Forme de comparaison : uniquement les caractères alphanumériques, en majuscules. */
export const normaliserImmat = (v) => String(v || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

/**
 * La plaque `immat` correspond-elle au terme cherché ?
 * Comparaison sur les deux formes normalisées, donc indifférente aux tirets et
 * aux espaces, de part et d'autre. Terme vide (ou fait de seuls séparateurs) :
 * pas de correspondance — c'est à l'appelant de gérer le « pas de filtre ».
 */
export const immatCorrespond = (immat, recherche) => {
  const q = normaliserImmat(recherche);
  return q ? normaliserImmat(immat).includes(q) : false;
};
